import { Dropdown, IDropdownOption, IDropdownStyles } from '@fluentui/react';
import React, { useRef } from 'react';
import { useQuery } from '@tanstack/react-query';
import { ApiCalls } from '../../../../api/api';
import { PROJECT_SOURCES } from '../../../../constants/queryKeys';

const dropdownStyles: Partial<IDropdownStyles> = { dropdown: { width: 225 } };

interface AdminProjectSourcesDropdownProps {
    callback: any;
    selectedProjectSource: any;
}

const AdminProjectSourcesDropdown: React.FC<AdminProjectSourcesDropdownProps> = props => {
    const defaultProjectSources = useRef([] as typeof projectSources).current;
    const { data: projectSources = defaultProjectSources } = useQuery({
        queryKey: [PROJECT_SOURCES],
        queryFn: () => ApiCalls.getProjectSources().then(res => res.data),
    });

    const projectSourcesDropdownOptions: IDropdownOption[] = projectSources.map(ps => ({ key: ps.id, text: ps.name })) as IDropdownOption[];

    return (
        <Dropdown
            label="Icon for Administrative Projects"
            options={projectSourcesDropdownOptions}
            selectedKey={props.selectedProjectSource ? props.selectedProjectSource.key : undefined}
            onChange={props.callback}
            placeholder="Select project source (icon)"
            styles={dropdownStyles}
        />
    );
};

export default AdminProjectSourcesDropdown;
